import { render, staticRenderFns } from "./LoginKeyboard.vue?vue&type=template&id=22f475ce&class=background-template&"
import script from "./LoginKeyboard.vue?vue&type=script&lang=js&"
export * from "./LoginKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./LoginKeyboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports